import ProductListPage from './product-list.container';

export default ProductListPage;